export default "__VITE_ASSET__BDaAZk7J__"